import { createGemFile } from './create'
import { downloadGemFile } from './download'

export const gemFiles = {
  create: createGemFile,
  download: downloadGemFile,
}
